import React, {useEffect, useState} from 'react';
import './Alert.sass';
import Button from "../ui/Button/Button";
import {useDispatch} from "react-redux";
import {gsap} from "gsap";
import {setAlert} from "../../store/actions/course.action";

const Alert = ({data, confirm, cancel}) => {
    const dispatch = useDispatch();

    useEffect(() => {
        gsap.from('.Alert',{opacity:0})
    }, []);

    const doConfirm = () =>{
        confirm();
    }

    const doCancel = () =>{
        gsap.to(".Alert",{opacity:0,onComplete:finish});
        if(cancel){
            cancel();
        }
    }

    const finish = () =>{
        dispatch(setAlert(null));
    }

    return (
        <div className="Alert">
            <div className="alert-panel">
                <div className="alert-panel-title">
                    {data.title}
                </div>
                <div className="alert-panel-divider"/>
                <div className="alert-panel-body">
                    {data.body}
                </div>
                <div className="alert-panel-button-row">
                    <Button data={data.confirm} callback={doConfirm} style={{
                        "flex":1
                    }}/>
                    <Button data={data.cancel} callback={doCancel} style={{
                        "flex":1
                    }}/>
                </div>
            </div>

        </div>
    );
};

export default Alert;